import { PERMISSIONS } from './permissions';

export const HOTEL_MODULES = Object.freeze({
  PMS: 'pms',
  CM: 'cm',
  RESTAURANT: 'restaurant',
  STOCK: 'stock',
  HALL: 'hall',
  INSIGHTS: 'insights',
});

export const MODULE_DEFINITIONS = Object.freeze({
  [HOTEL_MODULES.PMS]: {
    label: 'PMS',
    featurePermissions: [
      PERMISSIONS.DASHBOARD_VIEW,
      PERMISSIONS.BOOKING_OPERATIONS,
      PERMISSIONS.BOOKING_MODIFY,
      PERMISSIONS.CUSTOMER_MANAGE,
      PERMISSIONS.HOUSEKEEPING_MANAGE,
      PERMISSIONS.FINANCE_MANAGE,
      PERMISSIONS.CONFIGURATION_MANAGE,
      PERMISSIONS.INVENTORY_MANAGE,
      PERMISSIONS.DYNAMIC_PRICING_MANAGE,
    ],
  },
  pms_addons: {
    label: 'PMS Add-ons',
    dependsOn: [HOTEL_MODULES.PMS],
    featurePermissions: [
      PERMISSIONS.BOOKING_ENGINE_MANAGE,
      PERMISSIONS.WEB_CHECKIN_MANAGE,
      PERMISSIONS.AI_CHECKIN_MANAGE,
    ],
  },
  [HOTEL_MODULES.CM]: {
    label: 'Channel Manager',
    dependsOn: [HOTEL_MODULES.PMS],
    featurePermissions: [
      PERMISSIONS.DISTRIBUTION_MANAGE,
      PERMISSIONS.CHANNELHUB_MANAGE,
    ],
  },
  [HOTEL_MODULES.RESTAURANT]: {
    label: 'Restaurant',
    featurePermissions: [
      PERMISSIONS.POS_RESTAURANT_MANAGE,
      PERMISSIONS.POS_AUDIT_VIEW,
    ],
  },
  [HOTEL_MODULES.STOCK]: {
    label: 'Stock',
    featurePermissions: [PERMISSIONS.STOCK_MANAGE, PERMISSIONS.AI_INVENTORY_MANAGE],
  },
  [HOTEL_MODULES.HALL]: {
    label: 'Hall',
    // Hotel Additional Features only — independent of PMS package bundling.
    independent: true,
    featurePermissions: [PERMISSIONS.HALL_MANAGE],
  },
  [HOTEL_MODULES.INSIGHTS]: {
    label: 'Insights',
    independent: true,
    featurePermissions: [
      PERMISSIONS.DASHBOARD_VIEW,
      PERMISSIONS.REPORTS_VIEW,
      PERMISSIONS.BOOKING_OPERATIONS,
      PERMISSIONS.FINANCE_MANAGE,
      PERMISSIONS.INVENTORY_MANAGE,
      PERMISSIONS.CUSTOMER_MANAGE,
    ],
  },
});

export const PERMISSION_MODULE_MAP = Object.freeze(
  Object.entries(MODULE_DEFINITIONS).reduce((acc, [moduleCode, module]) => {
    module.featurePermissions.forEach((permissionCode) => {
      acc[permissionCode] = moduleCode;
    });
    return acc;
  }, {})
);

export const getModuleForPermission = (permissionCode) => PERMISSION_MODULE_MAP[permissionCode] || null;
